<template>
  <div class="sn-f-b-s discharge-medicine-detail">
    <sn-navigator id="CYDY" :initial="perpetual.FUNCTION_ID_CYDY"></sn-navigator>
    <div class="sn-f-1 sn-f-s-1 sn-f-col-b-s discharge-medicine-detail-region">
      <sn-breadcrumb :breadcrumb="[{
        title: $sn.utils.getFunctionTitle('0', perpetual.FUNCTION_ID_CYDY),
        replace: true,
        router: '/query/discharge-medicine',
      }, {
        title: `${$sn.utils.getFunctionTitle('0', perpetual.FUNCTION_ID_CYDY)}详情`
      }]"></sn-breadcrumb>
      <div class="sn-f-1 detail-blank">
        <div class="card-region" v-if="!$sn.validate.empty(medicineDetailInfo)">
          <div class="sn-fs-20 sn-fw-bold sn-fc-main">患者信息</div>
          <div class="sn-f-s-c patient-info">
            <div v-if="medicineDetailInfo.name">患者姓名：{{ medicineDetailInfo.name }}</div>
            <div v-if="medicineDetailInfo.sex">性别：{{ medicineDetailInfo.sex }}</div>
            <div v-if="medicineDetailInfo.age">年龄：{{ medicineDetailInfo.age }}岁</div>
            <div v-if="medicineDetailInfo.inCardNo">住院号：{{ medicineDetailInfo.inCardNo }}</div>
          </div>
          <div class="sn-fs-20 sn-fw-bold sn-fc-main">出院带药</div>
          <template v-if="!$sn.validate.empty(medicineInfo)">
            <div class="drug-box" v-for="(item, index) in medicineInfo" :key="index">
              <div class="sn-f-b-s drug-info">
                <div class="drug-name">
                  <div>{{ item.drugName }}({{ item.drugSpec }})</div>
                  <div class="drug-btn" v-if="item.drugType === '0'" @click="navigateUrl('instructions', item);">药品说明书</div>
                </div>
                <div class="drug-quantity">{{ `${item.drugQuantity}${item.drugUnit || ''}` }}</div>
              </div>
              <div class="sn-f-b-c drug-freq">
                <div>用法用量：{{ `${item.drugDose}${item.drugDoseUnit} ${item.drugFrequency} ${item.drugUsage}` }}</div>
              </div>
            </div>
            <div class="base-box" v-if="dischargeAbstract">
              <div class="division"></div>
              <div class="sn-fs-20 sn-fw-bold sn-fc-main">出院小结</div>
              <div class="tips" v-html="dischargeAbstract"></div>
            </div>
          </template>
          <sn-no-data message="暂未查询到该条出院带药详情，请稍后重试" v-else></sn-no-data>
        </div>
        <sn-no-data message="暂未查询到该条出院带药详情，请稍后重试" v-else></sn-no-data>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import Swagger from '@/common/utils/swagger';
import * as Messages from '@/common/utils/messages';
import * as ServiceConfig from '@/common/utils/service-config';
import * as Constants from '@/common/utils/constants';
import HomepageMixin from '@/common/mixin/homepage-mixin';

export default {
  mixins: [HomepageMixin],
  components: {},
  data() {
    return {
      perpetual: Constants,
      medicineInfo: [],
      medicineDetailInfo: {},
      dischargeAbstract: ''
    };
  },
  computed: {},
  watch: {},
  created: function() {
    document.title = `${this.$sn.utils.getFunctionTitle('0', this.perpetual.FUNCTION_ID_CYDY)}详情`;
    this.$route.meta.title = `${this.$sn.utils.getFunctionTitle('0', this.perpetual.FUNCTION_ID_CYDY)}详情`;
    this.medicineDetailInfo = this.$sn.utils.getHospitalSessionStorage('Discharge_Medicine_Info');
    this.handleMedicineInfo();
  },
  methods: {
    // 获取出院带药详情
    handleMedicineInfo() {
      if (this.$sn.validate.empty(this.medicineDetailInfo)) {
        this.medicineInfo = [];
        this.dischargeAbstract = '';
        return false;
      }
      const code = {
        [this.perpetual.HOSPITAL_ID_LCRM]: 'ea3f980b-f839-4064-b4ea-997e62b26769',
        [this.perpetual.HOSPITAL_ID_JNYZ]: 'ecd62b6169104949ad07a0aa34c4d440'
      };
      const params = {
        url: this.$sn.format.caption(Swagger.ordinaryTransmitLogin, [this.$sn.utils.getHospitalId(), code[this.$sn.utils.getHospitalId()]]),
        method: 'POST',
        header: true,
        data: this.$sn.utils.variableEncryption(this.$sn.format.xml({ OrderId: this.medicineDetailInfo.orderId }))
      };
      this.$sn.assembly.loading(true);
      this.$sn.utils.ordinaryRequest(params, ServiceConfig.ordinaryTransmitLoginComplete).then(result => {
        this.$sn.assembly.loading(false);
        if (result && result.code === 0 && result.data) {
          if (result.data.ResultCode === '0') {
            this.medicineInfo = result.data.Data;
            this.dischargeAbstract = result.data.dischargeAbstract;
          }
          else {
            this.$sn.assembly.toast({ caption: result.data.ResultMsg });
          }
        }
        else {
          this.$sn.assembly.toast({ caption: result?.msg || Messages.C001 });
        }
      });
    },
    navigateUrl(url, item, params, type = 'push') {
      if (this.$sn.validate.empty(url)) return false;
      if (url === 'instructions') {
        const code = {
          [this.perpetual.HOSPITAL_ID_LCRM]: 'bf2727e0-7907-48d5-b72f-3c84c9bd47d3',
          [this.perpetual.HOSPITAL_ID_JNYZ]: '823b05ee-6cc3-492f-b427-f75ed222622a'
        };
        this.$sn.assembly.loading(true);
        this.$sn.utils.ordinaryRequest({
          url: this.$sn.format.caption(Swagger.ordinaryTransmitLogin, [this.$sn.utils.getHospitalId(), code[this.$sn.utils.getHospitalId()]]),
          method: 'POST',
          header: true,
          data: this.$sn.utils.variableEncryption(this.$sn.format.xml({
            Data: JSON.stringify({
              drugId: item.drugCode,
              drugName: item.drugName
            }),
            PlatformId: this.$sn.utils.getPlatformType(),
            PlatformUserId: this.$sn.utils.getOpenId(),
            Type: '9'
          }))
        }, ServiceConfig.ordinaryTransmitLoginComplete).then(result => {
          this.$sn.assembly.loading(false);
          if (result) {
            if (result.code === 0) {
              if (result.data) {
                if (result.data.ResultCode === '0') {
                  if (result.data.Data && result.data.Data.url) {
                    this.navigateUrl(result.data.Data.url);
                  }
                  else {
                    this.$sn.assembly.modal({
                      caption: Messages.C002,
                      isCancel: false
                    });
                  }
                }
                else {
                  this.$sn.assembly.modal({
                    caption: result.data.ResultMsg,
                    isCancel: false
                  });
                }
              }
              else {
                this.$sn.assembly.modal({
                  caption: Messages.C002,
                  isCancel: false
                });
              }
            }
            else {
              this.$sn.assembly.modal({
                caption: result.msg,
                isCancel: false
              });
            }
          }
          else {
            this.$sn.assembly.modal({
              caption: Messages.C001,
              isCancel: false
            });
          }
        });
      }
      else {
        this.homepage_mixin_navigateUrl(url, item, params, type);
      }
    }
  },
  beforeDestroy() {}
};
</script>
<style lang="scss" scoped>
.discharge-medicine-detail {
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  background: $white;
  left: 0;
  top: 0;

  &-region {
    overflow: hidden;
    height: 100%;

    .detail-blank {
      overflow-y: auto;
      width: 100%;
      padding: 20px 20px 0;

      .card-region {
        width: 100%;
        padding: 24px;
        border-radius: 6px;
        box-shadow: 0 0 5px $shadow;

        .patient-info {
          color: $text1;
          margin: 12px 0 16px;
          padding-bottom: 16px;
          border-bottom: 1px solid $border1;

          div {
            margin-left: 20px;
          }

          div:first-child {
            margin-left: 0;
          }
        }

        .drug-box {
          margin-top: 12px;
          padding-bottom: 12px;

          &:not(:last-child) {
            border-bottom: 1px dotted $border1;
          }

          .drug-info {
            .drug-name {
              display: flex;
              flex: 1;

              .drug-btn {
                padding: 2px 8px;
                border-radius: 6px;
                border: 1px solid $main;
                font-size: 12px;
                color: $main;
                margin: 0 12px;
                cursor: pointer;
              }
            }
          }

          .drug-freq {
            margin-top: 6px;
            font-size: 14px;
            color: $text6;
          }
        }

        .base-box {
          margin-top: 10px;

          .tips {
            @include fs(14);

            color: $text1;

            &:not(:first-child) {
              margin-top: 12px;
            }
          }
        }
      }
    }
  }
}
</style>
